import React, { useState } from 'react';
import { MdEdit } from 'react-icons/md';
import { CrudIcon, HeadingWithCreateBtn, Search, Table } from 'src/components';
import DashboardLayout from 'src/containers/dashboard-layout';
import { useDispatch } from 'react-redux';
import { fetchItemCategories } from 'src/redux/action/item.action';
import { ThunkDispatch } from 'redux-thunk';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import AddDiscount from './crud/AddDiscount';
import useFetch from 'src/hooks/useFetch';
import { fetchDiscount } from 'src/redux/action/discount.action';
import { AiOutlinePlus } from 'react-icons/ai';
import Button from 'src/components/button';
interface IProps {}

const Discount: React.FC<IProps> = ({}) => {
  const [showModal, setShowModal] = React.useState(true);
  const [query, setQuery] = React.useState<string>('');
  const [editDiscount, setEditDiscount] = useState<boolean>(false);
  const [editDiscountId, setEditDiscountId] = useState('');
  const [editDiscountData, setEditDiscountData] = useState([]);
  const dispatch = useDispatch();
  const { discountData, error, loading } = useSelector(
    ({ itemDiscount }: RootState) => itemDiscount
  );
  const handleModal = () => {
    setShowModal(!showModal);
  };
  React.useEffect(() => {
    // if (discountData.length > 0) return;
    dispatch(fetchDiscount() as any);
  }, [dispatch]);

  const searchDiscountData = discountData?.discounts?.filter((item: any) => {
    if (query === '') {
      return item;
    } else if (item?.name?.toLowerCase().includes(query.toLowerCase())) {
      return item;
    }
  });

  const handleEditDiscount = (data: any) => {
    setEditDiscount(!editDiscount);
    setShowModal(false);
    setTimeout(() => {
      setShowModal(true);
    }, 100);
    setEditDiscountData(data?.cell?.row?.original);
    setEditDiscountId(data?.cell?.row?.original?.id);
  };

  const handleButtonClick = () => {
    setShowModal(false);
    setTimeout(() => {
      setShowModal(true);
    }, 100);
    setEditDiscount(false);
    setEditDiscountData([]);
  };

  const {
    data: itemsData,
    fetchData,
    isLoading,
    errorText,
  } = useFetch('/discounts');

  const tableColumn = [
    {
      Header: 'Discount Title',
      accessor: 'name',
    },
    {
      Header: 'Value',
      accessor: 'value',
    },
    {
      Header: 'Type',
      accessor: 'type',
    },

    {
      Header: 'Action',
      Cell: (row: any) => (
        <CrudIcon
          data={row?.cell?.row?.original}
          url="/discounts/remove"
          // fetchData={() => {}}
          fetchData={fetchDiscount() as any}
        >
          <div
            className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
            onClick={() => handleEditDiscount(row)}
          >
            <MdEdit color="#4062FF" />
          </div>
        </CrudIcon>
      ),
    },
  ];
  return (
    <>
      <div className="grid-cols-12 gap-4 grid z-2 text-black">
        <div className="col-span-12">
          <div className="flex items-center justify-between ">
            <Search
              placeholder="search discount"
              query={query}
              setQuery={setQuery}
            />
            <Button
              text={'Add Discount'}
              variant="primary"
              onClick={handleButtonClick}
              icon={<AiOutlinePlus size={20} />}
            />
          </div>
          <Table
            loading={isLoading}
            pagination={true}
            tableColumn={tableColumn}
            tableData={searchDiscountData}
          />
        </div>
      </div>
      <AddDiscount
        editDiscountData={editDiscountData}
        editDiscount={editDiscount}
        editDiscountId={editDiscountId}
        setEditDiscount={setEditDiscount}
        setEditDiscountId={setEditDiscountId}
        fetchData={() => {}}
        handleModal={handleModal}
        showModal={showModal}
      />
    </>
  );
};

export default React.memo(Discount);
